var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"inset-0 fixed bg-black/50 z-50 flex justify-center items-center"},[_c(_setup.LoadingIcon,{staticClass:"h-12 w-12 text-white"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }